module.exports = __webpack_public_path__ + "img/green_062.0b71c1e7.png";